var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileArrowUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7031 10.4531L7.95312 14.2031C7.51367 14.6426 7.51367 15.3544 7.95312 15.7941C8.39258 16.2337 9.10437 16.2335 9.54406 15.7941L11.375 13.9641V18.75C11.375 19.3711 11.8789 19.875 12.5 19.875C13.1211 19.875 13.625 19.3711 13.625 18.75V13.9641L15.4545 15.7936C15.6734 16.0172 15.9594 16.125 16.25 16.125C16.5406 16.125 16.8256 16.0151 17.0455 15.7954C17.4849 15.356 17.4849 14.6442 17.0455 14.2045L13.2955 10.4545C12.8562 10.0172 12.1438 10.0172 11.7031 10.4531ZM20.6234 4.37719L17.1252 0.878438C16.5594 0.316031 15.7953 0 15.0031 0H6.5C4.84297 0 3.5 1.34297 3.5 3L3.5003 21C3.5003 22.6566 4.84327 24 6.5003 24H18.5C20.15 24 21.5 22.65 21.5 21V6.49688C21.5 5.70469 21.1859 4.94062 20.6234 4.37719ZM19.25 21C19.25 21.4142 18.9142 21.75 18.5 21.75H6.50094C6.08666 21.75 5.75094 21.4142 5.75094 21L5.75 3.00609C5.75 2.59191 6.08581 2.25609 6.5 2.25609H14V6C14 6.82828 14.6717 7.5 15.5 7.5H19.2078V21H19.25Z",
    fill: "#707A83"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileArrowUpIcon);
export default __webpack_public_path__ + "static/media/file-arrow-up-icon.4f8210a08589a24770cc699442c2abc0.svg";
export { ForwardRef as ReactComponent };